<template>
  <OmtStickedModal v-if="isOpen" @close="close" data-cy="refund-create-terms-modal">
    <OmtTypography as="h1-bold" mb="24px" mx="auto" textAlign="center" style="text-transform: :uppercase;">
      Atenção
    </OmtTypography>

    <OmtTypography as="p1" mb="24px">
      <b>Canal exclusivo para AUTORIZAÇÃO. Demais solicitações, envie por e-mail para associado@omint.com.br.</b>
    </OmtTypography>

    <template #footer>
      <OmtButton w="100%" @click="continueClick"> Continuar </OmtButton>
    </template>
  </OmtStickedModal>
</template>

<script>
/**
 * @prop {Boolean} isOpen
 */
export default {
  props: {
    isOpen: {
      Type: Boolean
    }
  },
  methods: {
    close() {
      this.$emit("update:isOpen", false);
    },
    continueClick() {
      this.$emit("continue");
      this.close();
    }
  }
};
</script>
